import { fetchJSON } from '@/utils/http'
import { API_ROUTE } from '../backend/config'
import {
  CreateDepartmentParams,
  Department,
  ListDepartmentsResponse,
  UpdateDepartmentParams,
} from './types'

// Fetch all departments for the current organization
export const fetchDepartments = async (): Promise<ListDepartmentsResponse> => {
  return await fetchJSON(`${API_ROUTE}/departments`)
}

// Get a single department by ID
export const fetchDepartment = async (
  departmentId: string,
): Promise<Department> => {
  return await fetchJSON(`${API_ROUTE}/departments/${departmentId}`)
}

// Create a new department
export const createDepartment = async (
  params: CreateDepartmentParams,
): Promise<Department> => {
  return await fetchJSON(`${API_ROUTE}/departments`, {
    method: 'POST',
    body: JSON.stringify(params),
  })
}

// Update a department (rename, change description, or update members)
export const updateDepartment = async (
  departmentId: string,
  params: UpdateDepartmentParams,
): Promise<Department> => {
  return await fetchJSON(`${API_ROUTE}/departments/${departmentId}`, {
    method: 'PATCH',
    body: JSON.stringify(params),
  })
}

// Delete a department
export const deleteDepartment = async (departmentId: string): Promise<void> => {
  return await fetchJSON(`${API_ROUTE}/departments/${departmentId}`, {
    method: 'DELETE',
  })
}
